module.exports = __webpack_public_path__ + "static/media/tire-green-4.252ccf99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tire-green-4.png
// module id = 1146
// module chunks = 0